import { useMemo } from 'react';
import home from '~/assets/icons/home.svg';
import transfer from '~/assets/icons/transfer.svg';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { BankStages } from '../../models/Bank';
import {
	OverlayType,
	setActiveBankState,
	setOverlayVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppBankCards } from '../AppBankCards';
import {
	StyledBodyContainer,
	StyledContainer,
	StyledIconContainerBig,
	StyledIconContainerSmall,
	StyledMoneyContainer,
	StyledTopContainer,
} from './AppBankOverlay.styled';

const formatDate = (timestamp: number) => {
	const date = new Date(timestamp);
	const time = date.toLocaleTimeString('ru-RU', {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
		timeZone: 'Europe/Moscow',
	});
	const formattedDate = date.toLocaleDateString('ru-RU', {
		day: '2-digit',
		month: '2-digit',
		year: '2-digit',
		timeZone: 'Europe/Moscow',
	});

	return { time, date: formattedDate };
};

const AppBankOverlay = () => {
	const dispatch = useLayoutDispatch();
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const paymentType = useLayoutSelector((state) => state.bank.overlayType);
	const transferData = useLayoutSelector(
		(state) => state.bank.overlayTransferData,
	);
	const taxesData = useLayoutSelector((state) => state.bank.overlayTaxesData);

	const formattedDate = useMemo(() => {
		if (paymentType === OverlayType.Transfer) {
			return formatDate(transferData.date);
		}
		return formatDate(taxesData.date);
	}, [paymentType, transferData.date, taxesData.date]);

	return (
		<StyledContainer>
			<StyledTopContainer>
				<Text
					style={{
						fontSize: 18,
						fontWeight: 500,
						color: '#ffffff',
						marginTop: 68,
					}}
				>
					{paymentType === OverlayType.Transfer ? 'Перевод' : 'Оплата'}
				</Text>
				<StyledMoneyContainer>
					<Text>
						{paymentType === OverlayType.Taxes
							? taxesData.amount.toLocaleString('ru-RU')
							: transferData.amount.toLocaleString('ru-RU')}
					</Text>
					<CurrencyIcon icon={rubleIcon} size="lg" />
				</StyledMoneyContainer>
				<Text
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.24,
						marginTop: 3,
					}}
				>
					Операция {formattedDate.time} {formattedDate.date}
				</Text>
			</StyledTopContainer>
			<StyledBodyContainer>
				<StyledIconContainerBig>
					<StyledIconContainerSmall>
						<img src={paymentType === OverlayType.Transfer ? transfer : home} />
					</StyledIconContainerSmall>
				</StyledIconContainerBig>
				{paymentType === OverlayType.Transfer && (
					<Text
						style={{
							fontSize: 18,
							color: 'rgba(255, 255, 255, 0.5)',
							marginTop: 70,
							textAlign: 'center',
						}}
					>
						Вы успешно перевели деньги
						<br />
						игроку{' '}
						<span style={{ color: '#ffffff', fontWeight: 500 }}>
							{transferData.player}
						</span>
					</Text>
				)}
				{paymentType === OverlayType.Taxes && (
					<Text
						style={{
							fontSize: 18,
							color: 'rgba(255, 255, 255, 0.5)',
							marginTop: 70,
							textAlign: 'center',
						}}
					>
						Вы успешно оплатили налоги за
						<br />{' '}
						<span style={{ color: '#ffffff', fontWeight: 500 }}>
							Дом #{taxesData.apartment}
						</span>
					</Text>
				)}
				<AppBankCards compact />
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height50}
					style={{ width: 200, margin: '0 auto' }}
					onClick={() => {
						dispatch(setOverlayVisible(false));
						dispatch(setActiveBankState(BankStages.MAIN));
					}}
				>
					<Text>Продолжить</Text>
				</Button>
			</StyledBodyContainer>
		</StyledContainer>
	);
};

export { AppBankOverlay };
